import React, {memo} from 'react';
import {Platform, View} from 'react-native';

import { StyleSheet } from 'react-native';

import {SVGIcon, RNEIconButton, RNEText} from '../../components';
import useStores from '../../stores/useStores';
import { width, height, totalSize } from 'react-native-dimension';

interface RegistrationSuccessModalProps {
  onConfirm?: () => void;
}

function RegistrationSuccessModal(props: RegistrationSuccessModalProps) {
  const {authStore} = useStores();

  return (
    <View style={rneStyles.root}>
      <View style={{marginBottom: height(2)}}>
          <RNEText
            label={
              authStore.authData?.user.userRole === 'patient'
                ? 'AWESOME!'
                : 'Great job, Doc!'
            }
            variant="header"
            align="center"
            weight="600"
            color="primary"
            style={[
              {
                fontSize:totalSize(3),
                fontFamily: 'Quicksand-Bold'

              }
            ]}
          />
      </View>
      <RNEText
        label="Your account has been verified. You can now start using House Call to proceed with your medical consultations."
        variant="body"
        align="center"
        style={[
          {
            fontSize:totalSize(1.7),
            fontFamily: 'Quicksand-Medium'

          }
        ]}
      />

      <View style={rneStyles.actionContainer}>
        <RNEIconButton
          icon={<SVGIcon name="check-white" size={totalSize(5)} />}
          color="secondary"
          size={totalSize(6.5)}
          onPress={props.onConfirm}
          raised={Platform.OS !== 'web'}
        />
      </View>
    </View>
  );
}

const rneStyles = StyleSheet.create(({
  root: {
    maxWidth: Platform.OS === 'web' ? 420 : '80%',
    padding: Platform.OS === 'web' ? 32 : 16,
  },
  actionContainer: {
    marginTop: height(3.5),
    alignItems: 'center',
  },
}));

export default memo(RegistrationSuccessModal);
